import { createReducer, } from 'typesafe-actions';

import { fetchProducts, } from './actions';
import { handleFilters, } from './selectors';

export const productsInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    errorCode: null,
    data: null,
    // TODO PB Make this more dynamic and remove awareness of filters.
    filters: {
        page: 1,
        limit: 10,
        primarySchool: [],
        bookSeries: [],
        schoolSubjects: [],
        highSchool: [],
        gymnasium: [],
        productType: [],
        bookTypes: [],
    },
};

const productsReducer = createReducer(productsInitialState)
    .handleAction(fetchProducts.request, (state, action) => ({
        ...state,
        isLoading: true,
        filters: handleFilters(state, action),
    }))
    .handleAction(fetchProducts.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchProducts.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.data ?? action.payload.message,
        errorCode: action.payload?.code,
    }));

export default productsReducer;
